import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getEquipmentDocuments: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENTS,
	},
	getEquipmentDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].GET_EQUIPMENT_DOCUMENT,
	},
	createEquipmentDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].CREATE_EQUIPMENT_DOCUMENT,
	},
	patchEquipmentDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PATCH_EQUIPMENT_DOCUMENT,
	},
	putEquipmentDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].PUT_EQUIPMENT_DOCUMENT,
	},
	deleteEquipmentDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_DOCUMENTS].DELETE_EQUIPMENT_DOCUMENT,
	},
}
